import * as GET_BUYING_SESSION_PRODUCT_COMMENTS from './getBuyingSessionProductComments.graphql'

export { GET_BUYING_SESSION_PRODUCT_COMMENTS }
